import React, { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';
import api from '../../services/api';
import { inputClass } from './shared';

// Search-as-you-type picker for CRM records. The server returns only records this user may see.
export default function RecordPicker({ type, value, onChange }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [picked, setPicked] = useState(null);
  const timer = useRef();

  useEffect(() => {
    if (!open) return undefined;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      api.get('/linkedin-ai/crm-search', { params: { type, q } }).then((r) => setResults(r?.data?.data?.results || [])).catch(() => setResults([]));
    }, 250);
    return () => clearTimeout(timer.current);
  }, [q, open, type]);

  if (value && picked?.id === value) {
    return (
      <div className="flex items-center justify-between gap-2 h-9 px-3 bg-[#EAF4FE] border border-[#B9D9F7] rounded text-[13px]">
        <span className="truncate">{picked.label}{picked.sub ? ` · ${picked.sub}` : ''}</span>
        <button type="button" aria-label={`Clear ${type}`} onClick={() => { setPicked(null); onChange(undefined); }}><X size={14} /></button>
      </div>
    );
  }
  if (value) {
    return (
      <div className="flex items-center justify-between gap-2 h-9 px-3 bg-[#EAF4FE] border border-[#B9D9F7] rounded text-[13px]">
        <span className="truncate">Selected {type}</span>
        <button type="button" aria-label={`Clear ${type}`} onClick={() => onChange(undefined)}><X size={14} /></button>
      </div>
    );
  }
  return (
    <div className="relative">
      <input className={inputClass} placeholder={`Search ${type}s…`} value={q} onFocus={() => setOpen(true)} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && (
        <ul role="listbox" className="absolute z-20 mt-1 w-full max-h-56 overflow-auto bg-white border border-[#D8DDE6] rounded shadow-[0_4px_12px_rgba(0,0,0,0.12)]">
          {results.length === 0 ? <li className="px-3 py-2 text-[12px] text-[#706E6B]">No matching records you can access</li> : results.map((r) => (
            <li key={r.id} role="option">
              <button type="button" className="w-full text-left px-3 py-2 hover:bg-[#F3F2F2] text-[13px]" onMouseDown={(e) => e.preventDefault()} onClick={() => { setPicked(r); onChange(r.id); setOpen(false); setQ(''); }}>
                {r.label}<span className="block text-[11px] text-[#706E6B]">{r.sub}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
